import React, { FC, memo } from 'react'
import { Button, Space, Typography } from 'antd'
import { VStack } from '../../ui/Stack'

export type ReportStatus = 'idle' | 'pending' | 'sent' | 'sent_retry' | 'failed'

interface PageErrorProps {
  className?: string
  reportStatus?: ReportStatus
  reportSending?: boolean
  onRetryReport?: () => void
  isChunkLoadError?: boolean
}

function reportMessage(status: ReportStatus): string | null {
  switch (status) {
    case 'sent':
      return 'Отчёт уже отправлен'
    case 'sent_retry':
      return 'Отчёт успешно отправлен'
    case 'failed':
      return 'Отправить отчёт не удалось'
    default:
      return null
  }
}

export const PageError: FC<PageErrorProps> = memo(props => {
  const {
    className,
    reportStatus = 'idle',
    reportSending = false,
    onRetryReport,
    isChunkLoadError = false,
  } = props
  const reloadPage = () => window.location.reload()
  const statusText = reportMessage(reportStatus)
  const showRetry = reportStatus === 'failed' && Boolean(onRetryReport)

  const title = isChunkLoadError
    ? 'Приложение обновилось, нужна перезагрузка страницы'
    : 'Произошла непредвиденная ошибка!'

  const description = isChunkLoadError
    ? 'Сначала сохраните данные на странице, затем перезагрузите вкладку, чтобы подтянуть актуальные файлы. Несохранённые изменения будут потеряны.'
    : null

  return (
    <VStack
      align="center"
      justify="center"
      gap="16"
      style={{ height: '100vh' }}
      className={className}
    >
      <Typography.Text>{title}</Typography.Text>
      {description && <Typography.Text type="secondary">{description}</Typography.Text>}
      {statusText && (
        <Typography.Text type={reportStatus === 'failed' ? 'danger' : 'secondary'}>
          {statusText}
        </Typography.Text>
      )}
      <Space>
        {showRetry && (
          <Button onClick={onRetryReport} loading={reportSending}>
            Отправить повторно
          </Button>
        )}
        <Button type="primary" onClick={reloadPage}>
          Перезагрузить страницу
        </Button>
      </Space>
    </VStack>
  )
})

PageError.displayName = 'PageError'
